
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
  Stack
} from '@mui/material';
import { CheckCircleOutline, ErrorOutline } from '@mui/icons-material';

ModalConfimacao.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setShowModal: PropTypes.func.isRequired,
  funcPos: PropTypes.func,
  msgModalConfirmarAcao: PropTypes.string
};

export function ModalConfimacao({ showModal, setShowModal, funcPos, msgModalConfirmarAcao }) {
  const handleClose = () => setShowModal(false);

  const handleConfirm = () => {
    if (funcPos) funcPos();
    setShowModal(false);
  };

  return (
    <Dialog
      open={showModal}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth
      maxWidth="sm"
    >
      {/* Título vazio mantido para espaçamento, se desejado, ou removido */}
      <DialogContent>
        <Typography variant="h6" align="center" sx={{ mt: 2, mb: 2 }}>
          {msgModalConfirmarAcao}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 3, gap: 2 }}>
        <Button 
            variant="contained" 
            color="success" 
            onClick={handleConfirm}
            fullWidth
        >
          Sim
        </Button>
        <Button 
            variant="contained" 
            color="error" 
            onClick={handleClose}
            fullWidth
        >
          Não
        </Button>
      </DialogActions>
    </Dialog>
  );
}

// --- Modal de Sucesso ---
ModalSucesso.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setShowModal: PropTypes.func.isRequired,
  msg: PropTypes.string.isRequired,
  funcPos: PropTypes.func.isRequired
};

export function ModalSucesso({ showModal, setShowModal, msg, funcPos }) {
  const handleClose = () => {
    setShowModal(false);
    // Executa funcPos ao fechar (conforme lógica original no clique do OK)
    // Se funcPos só deve rodar no OK, mova apenas para o onClick do botão.
  };

  const handleOk = () => {
      setShowModal(false); 
      funcPos();
  }

  return (
    <Dialog
      open={showModal}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        <Stack direction="row" alignItems="center" spacing={2}>
          <CheckCircleOutline color="success" sx={{ fontSize: 40 }} />
          <Typography variant="h5">Sucesso</Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Typography variant="h6" align="center" sx={{ my: 3 }}>
          {msg}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Button 
          variant="contained" 
          color="success" 
          onClick={handleOk}
          fullWidth
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

// --- Modal de Loading ---
ModalLoad.propTypes = {
  showModal: PropTypes.bool.isRequired
};

export function ModalLoad({ showModal }) {
  return (
    <Dialog
      open={showModal}
      // Impede fechar clicando fora ou com ESC (backdrop="static")
      disableEscapeKeyDown
      onClose={(event, reason) => {
        if (reason !== 'backdropClick') {
          // Lógica opcional se quiser permitir fechar de outra forma
        }
      }}
      aria-labelledby="loading-dialog"
    >
      <DialogTitle id="loading-dialog">Carregando...</DialogTitle>
      <DialogContent sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </DialogContent>
    </Dialog>
  );
}

// --- Modal de Erro ---
ModalErro.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setShowModal: PropTypes.func.isRequired,
  msg: PropTypes.string.isRequired,
  funcPos: PropTypes.func.isRequired
};

export function ModalErro({ showModal, setShowModal, msg, funcPos }) {
  const handleClose = () => {
    setShowModal(false);
    funcPos();
  };

  return (
    <Dialog
      open={showModal}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        <Stack direction="row" alignItems="center" spacing={1}>
          <ErrorOutline color="error" sx={{ fontSize: 35 }} />
          <Typography variant="h5" component="span" color="error">
             Erro!
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1">
          {msg}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit">
            Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}